module.exports = __webpack_public_path__ + "static/media/Anything Goes_Full.baf2863a.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/AnythingGoes/Anything Goes_Full.mp3
// module id = 111
// module chunks = 0